import styled from '@emotion/styled'
import { Headline } from 'components'
import Preface from 'components/Preface'

const LoyaltyStatusView = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
`

const LoyaltyStatusCount = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: -0.2 rem;

  span {
    display: block;
    line-height: 1;
  }
`

const LoyaltyStatusLabel = styled(Preface)`
  margin: 0 0 0.3rem 0.6rem;
`

interface LoyaltyStatusProps {
  count?: number | string
  name?: string
  children?: React.ReactNode
}

const LoyaltyStatus = ({ count, name, children }: LoyaltyStatusProps) => {
  return (
    <LoyaltyStatusView>
      <LoyaltyStatusCount>
        <Headline size="h1">{count}</Headline>
        <LoyaltyStatusLabel size="xSmall">{name}</LoyaltyStatusLabel>
      </LoyaltyStatusCount>
      {children}
    </LoyaltyStatusView>
  )
}

export default LoyaltyStatus
